import { useEffect, useState } from "react";

export type ReceivedProps = {
  isOpen: boolean;
  onCancel: () => void;
  onOk: (selectedImg: string) => void;
  imagePaths: string[];
  selectedImage: string;
};

const useModalSelectIcon = (props: ReceivedProps) => {
  const [currentSelectedImage, setCurrentSelectedImage] = useState<string>("");

  useEffect(() => {
    if (props?.selectedImage) {
      setCurrentSelectedImage(props?.selectedImage);
    } else {
      setCurrentSelectedImage("");
    }
  }, [props?.selectedImage]);

  return {
    ...props,
    currentSelectedImage,
    setCurrentSelectedImage,
  };
};

export type Props = ReturnType<typeof useModalSelectIcon>;

export default useModalSelectIcon;
